export interface Contact{
    Email:string;
    Name:string;
    Phone:string;
}

export class ContactFormValues implements Partial<Contact>{
    Email ='';
    Name='';
    Phone='';

    constructor(init?: Partial<Contact>) {
        Object.assign(this, init);
      }
}